import React, { useRef } from "react";
import PersonInMobileIcon from "../../../../../assets/Images/TestImg/SchoolImg.png";
import SignatureImg from "../../../../../assets/Images/TestImg/Signature.png";
import Title from "../../../../Universal/Title.component";
// import html2pdf from "html2pdf.js";
import "../../../../../styles/ComponentsStyles/Operational/Academic/Events/EventPreviewModal.style.css";
const EventDetails = () => {
  const downloadPageRef = useRef(null);
  const downloadReport = () => {
    // if (!downloadPageRef) return;
    // var opt = {
    //   margin: [0.1, 0.1],
    //   filename: "myfile.pdf",
    //   image: { type: "jpeg", quality: 1 },
    //   html2canvas: { scale: 2 },
    //   jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
    // };
    // document.body.classList.add("print-mode");
    // html2pdf()
    //   .from(downloadPageRef.current)
    //   .set(opt)
    //   .save()
    //   .then(() => {
    //     document.body.classList.remove("print-mode");
    //   });
  };
  return (
    <div className="w-full pt-2 p-2 flex-col align-center justify-start g-2">
      <div className="w-full flex-row align-center justify-end">
        <button className="actionBtn" onClick={downloadReport}>
          Download
        </button>
      </div>
      <hr className="w-full border-grayColor" />
      <div
        ref={downloadPageRef}
        className="flex-col align-center justify-start g-2"
      >
        <div className="flex-col align-center justify-start g-1">
          <img src={PersonInMobileIcon} alt="" />
          <h3 className="t-24 poppins">
            Elementary School of Business and Social Sciences
          </h3>
        </div>
        <h3
          className="color-grayColor poppins weight-500"
          style={{ fontSize: "1.3vw" }}
        >
          Exam routines for class 8
        </h3>
        <hr className="w-full" color="#e5e5e5" />

        <div className="w-full flex-col align-start justify-start g-1">
          <Title>Class 8: </Title>

          <table className="eventstable" style={{ transform: "scale(1)" }}>
            <thead>
              <tr>
                <th>Days</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ul className="w-full flex-row align-start justify-start">
          <li className="t-16 poppins">
            <b>01:00 PM to 02:00 PM is for ‘BREAK TIME’.</b>
          </li>
        </ul>

        <div className="w-full flex-row align-start justify-start">
          <table className="subjectCodeTable">
            <thead>
              <tr>
                <th>Subject name</th>
                <th>Subject code</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
            </tbody>
          </table>
          <hr  color="#6f944e" />
          <table className="subjectCodeTable">
            <thead>
              <tr>
                <th>Subject name</th>
                <th>Subject code</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
              <tr>
                <td>Bengali</td>
                <td>BEN</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="w-full flex-col align-start justify-start g-1">
          <p className="t-14 poppins">Date: 02 Oct, 2024</p>
          <div className="flex-row align-center justify-between">
            <div className="flex-col align-start justify-start g-1">
              <h3 className="t-16 poppins">
                Elementary School of Business and Social Sciences
              </h3>
              <address className="t-15 poppins" style={{ width: "50%" }}>
                15, Grand Trunk Rd, Deshbandhu Park, Uttarpara, Kolkata, West
                Bengal 700134
              </address>
            </div>

            <div className="flex-col align-center justify-center g-1">
              <img src={SignatureImg} alt="" style={{ height: "8rem" }} />
              <hr className="w-full" />
              <p className="t-14 pippins">
                Authorized Signatory (Academic head)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetails;
